var luxxTranslations = JSON.parse(document.getElementById('LuxxTranslations')?.textContent || '{}');

// Optional workshop priority: one non-shipping service per order.
const luxxPriority = (() => {
  const handle = 'preparation-prioritaire-expedition-sous-24-h-ouvrees';
  const root = window.Shopify?.routes?.root || '/';
  const english = document.documentElement.lang.startsWith('en');
  let serviceRequest;
  const text = english ? {
    title: 'Priority preparation · +€5 per order',
    detail: 'Prepared and dispatched within 24 business hours.',
    error: 'This option could not be updated. Please try again.'
  } : {
    title: 'Préparation prioritaire · +5 € par commande',
    detail: 'Traitement et expédition sous 24 h ouvrées.',
    error: 'Cette option n’a pas pu être mise à jour. Veuillez réessayer.'
  };
  async function json(url, body) {
    const response = await fetch(root + url, { credentials: 'same-origin', cache: 'no-store', ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : {}) });
    const result = await response.json();
    if (!response.ok) throw new Error(text.error);
    return result;
  }
  async function render(context, refresh, setBusy) {
    const host = context.querySelector('.drawer-summary') || context.querySelector('form:has([name="checkout"])');
    if (!host) return;
    serviceRequest ||= json('products/' + handle + '.js').catch(error => { serviceRequest = null; throw error; });
    const [product, cart] = await Promise.all([serviceRequest, json('cart.js')]);
    const variant = product.variants[0];
    if (!variant?.available) return;
    const serviceItems = cart.items.filter(item => item.product_id === product.id);
    const goods = cart.items.filter(item => item.product_id !== product.id);
    // Remove an orphaned service and normalize its quantity if the cart was edited elsewhere.
    if (serviceItems.length && (!goods.length || serviceItems.length > 1 || serviceItems[0].quantity !== 1)) {
      const updates = Object.fromEntries(serviceItems.map((item, index) => [item.key, goods.length && index === 0 ? 1 : 0]));
      await json('cart/update.js', { updates });
      await refresh();
      return;
    }
    if (!goods.length) return;
    host.querySelector('[data-priority-service]')?.remove();
    const box = document.createElement('div');
    box.dataset.priorityService = '';
    box.style.cssText = 'margin:16px 0;padding:14px;border:1px solid #a79887;border-radius:3px;text-align:left;';
    const label = document.createElement('label');
    label.style.cssText = 'display:flex;align-items:flex-start;gap:10px;cursor:pointer;font-size:14px;line-height:1.5;';
    const input = document.createElement('input');
    input.type = 'checkbox'; input.checked = serviceItems.length > 0;
    input.style.cssText = 'width:18px;height:18px;flex:0 0 18px;margin:2px 0 0;accent-color:#3b2f24;';
    const copy = document.createElement('span');
    const title = document.createElement('strong'); title.textContent = text.title;
    const detail = document.createElement('span'); detail.textContent = text.detail;
    detail.style.cssText = 'display:block;font-size:12px;line-height:1.5;margin-top:5px;font-weight:400;';
    copy.append(title, detail); label.append(input, copy); box.append(label);
    const errorMessage = document.createElement('p'); errorMessage.setAttribute('role', 'status');
    errorMessage.style.cssText = 'font-size:12px;margin:6px 0 0;'; box.append(errorMessage);
    host.insertBefore(box, host.querySelector('.drawer-total, .price, [name="update"], [name="checkout"]'));
    // The service is always a single fee; customers remove it with this checkbox.
    context.querySelectorAll('article').forEach(article => {
      if (!article.querySelector('a[href*="/products/' + handle + '"]')) return;
      const quantity = article.querySelector('input[name="updates[]"]');
      if (quantity) { quantity.value = '1'; quantity.min = '1'; quantity.max = '1'; quantity.readOnly = true; }
    });
    input.addEventListener('change', async () => {
      const selected = input.checked; input.disabled = true; setBusy(true);
      try {
        if (selected) await json('cart/add.js', { items: [{ id: variant.id, quantity: 1 }] });
        else await json('cart/update.js', { updates: Object.fromEntries(serviceItems.map(item => [item.key, 0])) });
        await refresh();
      } catch (error) { input.checked = !selected; errorMessage.textContent = text.error; }
      finally { input.disabled = false; setBusy(false); }
    });
  }
  return { render };
})();

(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const trigger = document.querySelector('[data-cart-trigger]');
  if (!drawer || !trigger || typeof drawer.showModal !== 'function') return;
  const content = drawer.querySelector('[data-cart-drawer-content]');
  const status = drawer.querySelector('[data-drawer-status]');
  const closeButton = drawer.querySelector('[data-drawer-close]');
  let busy = false, opener = trigger, oldOverflow = '';
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-controls', drawer.id);
  trigger.setAttribute('aria-expanded', 'false');
  const setBusy = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-drawer-quantity], [name="update"], [name="checkout"]').forEach(el => el.disabled = value);
  };
  const syncCount = count => {
    let badge = trigger.querySelector('.bag-count');
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'bag-count'; badge.setAttribute('aria-hidden', 'true'); trigger.append(badge); }
      badge.textContent = count;
    } else if (badge) badge.remove();
    trigger.setAttribute('aria-label', luxxTranslations["Panier"] + ' (' + count + ')');
  };
  async function refresh() {
    const url = new URL(drawer.dataset.sectionUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(luxxTranslations["Le panier ne peut pas être actualisé."]);
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = parsed.querySelector('[data-cart-drawer-content]');
    if (!next) throw new Error(luxxTranslations["Le panier ne peut pas être actualisé."]);
    content.replaceChildren(...Array.from(next.childNodes).map(node => document.importNode(node, true)));
    syncCount(Number(next.dataset.count || 0));
    await luxxPriority.render(content, refresh, setBusy).catch(() => {});
  }
  async function update(removeKey) {
    if (busy) return;
    const quantities = [...drawer.querySelectorAll('[data-drawer-quantity]')];
    if (quantities.some(input => !input.checkValidity())) { quantities.find(input => !input.checkValidity()).reportValidity(); return; }
    const focusedId = document.activeElement?.id;
    const updates = Object.fromEntries(quantities.map(input => [input.dataset.key, Number(input.value)]));
    if (removeKey) updates[removeKey] = 0;
    setBusy(true); status.textContent = luxxTranslations["Mise à jour…"];
    try {
      const response = await fetch(drawer.dataset.updateUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates, attributes: { 'Gravure du cadeau offert': '', 'Cadeau gravé dès 80 €': '' } }) });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : luxxTranslations["La modification a échoué. Veuillez réessayer."]);
      syncCount(result.item_count);
      await refresh();
      status.textContent = luxxTranslations["Panier mis à jour."];
      if (drawer.open) (focusedId && drawer.querySelector('#' + CSS.escape(focusedId)) || closeButton).focus();
    } catch (error) { status.textContent = error.message + luxxTranslations[" Vous pouvez utiliser « Voir le panier »."]; }
    finally { setBusy(false); }
  }
  trigger.addEventListener('click', async event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (drawer.open) return;
    opener = document.activeElement; oldOverflow = document.documentElement.style.overflow;
    drawer.showModal(); document.documentElement.style.overflow = 'hidden'; trigger.setAttribute('aria-expanded', 'true');
    setBusy(true); status.textContent = luxxTranslations["Chargement du panier…"];
    try { await refresh(); status.textContent = ''; }
    catch { status.textContent = luxxTranslations["Actualisation indisponible. Ouvrez « Voir le panier » pour vérifier votre commande."]; }
    finally { setBusy(false); }
  });
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    trigger.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus();
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-drawer-close]')) { drawer.close(); return; }
    if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close(); }
    const remove = event.target.closest('[data-drawer-remove]');
    if (remove) { event.preventDefault(); update(remove.dataset.key); }
  });
  drawer.addEventListener('change', event => { if (event.target.matches('[data-drawer-quantity]')) update(); });
  drawer.addEventListener('submit', event => {
    if (!event.target.matches('[data-drawer-form]') || event.submitter?.name === 'checkout') return;
    event.preventDefault(); update();
  });
})();
// The full cart page shares the same optional service.
(() => {
  const main = document.querySelector('main');
  const form = main?.querySelector('form:has([name="checkout"])');
  if (!form) return;
  const busy = value => form.querySelectorAll('button, input').forEach(input => { input.disabled = value; });
  document.querySelector('[data-cart-drawer]')?.addEventListener('close', () => location.reload());
  luxxPriority.render(main, async () => location.reload(), busy).catch(() => {});
})();
